module.exports = __webpack_public_path__ + "img/interior.4f2e685d.gif";